import {s_char_talents} from "../../_signals/s_char";
import {spellweavingTalents} from "../../_helper/spellweavingTalents";

export const getWavingTalent = (discipline: string) => {
    const talents = s_char_talents.value;
    if (talents) {
        return talents.find((s) => s.name === 'Fadenweben' && s.discipline ===discipline);
    }

    return null;
}